/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Permutationcmd1Inputs */



/**
* | output |
* | --- |
* | "Permutation command" |
*
* @param {Br_History_Key_Permutationcmd1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_permutationcmd1 = /** @type {((inputs?: Br_History_Key_Permutationcmd1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Permutationcmd1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Permutation command")
	return /** @type {LocalizedString} */ ("Commande de permutation")
});
export { br_history_key_permutationcmd1 as "br_history_key_permutationCmd" }